<template>
    <div class="loginAll">
        <div class="topNav">
            <div></div>
            <strong>帐号登录</strong>
            <div></div>
        </div>
        <div class="login_contaior">
            <div class="lg_logo"><img src="../assets/images/logo.png" /></div>
            <div class="lg_content">
                <div class="lg_yzm_tab" v-show="lgTab == 1">
                    <div class="lg_line">
                        <input type="text" class="inputname" v-model="phone" placeholder="手机号" />
                    </div>
                    <div class="lg_line">
                        <input type="text" class="inputyzm" v-model="code" placeholder="验证码" />
                        <input type="button" class="yzmbutton" @click="getPhoneCode()" value="获取验证码" v-show="timeCountDown == 0"  />
                        <input type="button" class="yzmbutton" v-model="timeCountDown" v-show="timeCountDown > 0" />
                    </div>
                    <div style="display: none" class="lgtishi"><p>提示：登录成功</p></div>
                    <div class="lgprotcol">
                        <input type="checkbox" v-model="agreeVal" />勾选即视为同意<a href="https://www.dmzj.com/zt/dmzj201712/userprot.html" target="_blank"
                    >《用户服务协议》</a
                    ><a href="https://zt.dmzj.com/yinsicelue/index.html" target="_blank">《动漫之家隐私策略》</a>
                    </div>
                    <div class="lg_submit" @click="login">登录</div>
                    <div class="lg_itemfun">
                        <div @click="tabmenu(2)">帐号密码登录</div>
<!--                        <div><router-link to="/Forgetpwd">忘记密码</router-link></div>-->
                    </div>
                </div>

                <div class="lg_yzm_tab" v-show="lgTab == 2">
                    <div class="lg_line">
                        <input
                            type="text"
                            class="inputname"
                            placeholder="用户名/手机/邮箱"
                            v-model="username"
                        />
                    </div>
                    <div class="lg_line">
                        <input type="password" class="inputpwd" placeholder="密码"  v-model="passwd"/>
                    </div>

<!--                    <div class="lgtishi"><p>提示：登录成功</p></div>-->
                    <div class="lgprotcol">
                        <input type="checkbox" v-model="agreeValPasswd" />勾选即视为同意<a href="https://www.dmzj.com/zt/dmzj201712/userprot.html" target="_blank"
                    >《用户服务协议》</a
                    ><a href="https://zt.dmzj.com/yinsicelue/index.html" target="_blank">《动漫之家隐私策略》</a>
                    </div>
                    <div class="lg_submit" @click="userLogin">登录</div>
                    <div class="lg_itemfun">
                        <div @click="tabmenu(1)">验证码登录</div>
<!--                        <div><router-link to="/Forgetpwd">忘记密码</router-link></div>-->
                    </div>
                </div>
            </div>
            <!-- <div class="lg_sanfang">
                <div class="lg_sf_tit">-第三方登录-</div>
                <div class="lg_sf_fun">
                  <a class="sf_ico"><img src="../assets/images/bg_btn_wx.png" /></a>
                    <a class="sf_ico" :href="'https://graph.qq.com/oauth2.0/authorize?client_id=101144087&redirect_uri=https://i.dmzj.com/login/qq&response_type=code&state='+this.redirectUrlEnCode"><img src="../assets/images/bg_btn_qq.png" /></a>
                    <a class="sf_ico" :href="'https://api.weibo.com/oauth2/authorize?client_id=1097110952&redirect_uri=https://i.dmzj.com/login/weibo&response_type=code&state='+this.redirectUrl">
                        <img src="../assets/images/bg_btn_sina.png" />
                    </a>
                </div>
                <div class="sf_warn">第三方登录帐号资料在不同版本APP不互通</div>
            </div> -->
        </div>

        <div class="popscreen" v-if="showPop"></div>
        <div class="popyzm_div" v-if="showPop">
             <div class="yzm_con">
                 <div class="yzm_line"><input type="text" class="poptext" v-model="yzm" /><img @click="refreshCode" class="yzmimg" :src="codeUrl" />
                 </div>
                 <div class="yzm_line"><div class="popsubmit" @click="getSmsCode">提交</div></div></div>
            <div class="yzm_close"><img src="../assets/images/closeico.png" @click="showPop=false" /> </div>
        </div>
    </div>
</template>
<script>

import axios from "_axios@0.24.0@axios";

export default {
    data() {
        return {
            lgTab: 1,
            redirectUrl: "",
            redirectUrlEnCode: "",
            phone: "",
            code: "",
            yzm: "",
            showPop: false,
            codeUrl: "",
            timeCountDown: 0,
            agreeVal: false,
            username: "",
            passwd: "",
            agreeValPasswd: false,
            domain: ""
        };
    },
    mounted() {
        this.redirectUrl = this.$route.query.to || "https://m.dmzj.com/my.html"
        this.redirectUrlEnCode = encodeURIComponent(this.redirectUrl)
        if(this.$customMethods.checkLogin()) {
            window.location.href = this.redirectUrl
        }
        let location = window.location.href
        if(location.indexOf("idmzj.com") > -1) {
            this.domain = "nnuser.idmzj.com"
        }else {
            this.domain = "user.dmzj.com"
        }
        console.log(location)
        //获取验证码倒计时
        this.checkCountDown()
    },
    methods: {
        tabmenu(e) {
            this.lgTab = e;
        },
        getPhoneCode(){
            if(!this.$customMethods.validPhone(this.phone)){
                this.$message.error("请输入正确的手机号")
                return
            }
            this.codeUrl = "http://i.dmzj.com/code/webLoginCode?tel="+this.phone
            this.showPop = true
        },
        refreshCode(){
           this.codeUrl = "http://i.dmzj.com/code/webLoginCode?tel="+this.phone+"&"+Math.random()
        },
        getSmsCode(){
            if(this.yzm.length != 5) {
                this.$message.error("请输入正确的图片验证码")
                return
            }
            this.$axios.defaults.withCredentials = false
            this.$axios.get("https://v3api.dmzj.com/account/sendsms?type=3&tel="+this.phone+"&code="+this.yzm).then((res)=>{
                if(res.data.code == 0) {
                    this.showPop = false
                    this.yzm = ""
                    this.$message.success("短信发送成功")
                    let timeNowStamp = Date.parse(new Date()) / 1000
                    localStorage.setItem('getCodeTime', timeNowStamp)
                    this.timeCountDown = 60
                    this.countDown()
                }else{
                    this.$message.error(res.data.msg)
                }
            })
        },
        countDown(){
            var that = this
            if(this.timeCountDown > 0) {
                this.timeCountDown -= 1
                setTimeout(that.countDown, 1000)
            }else{
                localStorage.removeItem("getCodeTime")
            }
        },
        checkCountDown(){
            let getCodeTime = localStorage.getItem('getCodeTime')
            if(getCodeTime) {
                getCodeTime = parseInt(getCodeTime)
                if(getCodeTime > 0) {
                    let timeNowStamp = Date.parse(new Date()) / 1000
                    this.timeCountDown = getCodeTime + 60 - timeNowStamp
                    if(this.timeCountDown < 0) {
                        this.timeCountDown = 0
                    }
                    if(this.timeCountDown > 0){
                        this.countDown()
                    }
                }
            }
        },
        login(){
            if(!this.agreeVal){
                this.$message.error("请先同意隐私政策和用户协议")
                return
            }
            if(!this.$customMethods.validPhone(this.phone)) {
                this.$message.error("请输入正确的手机号码")
                return
            }
            if(this.code.length != 6) {
                this.$message.error("请输入正确的短信验证码")
                return
            }
            this.$axios.defaults.withCredentials = true
            this.$axios.post('https://'+this.domain+'/login/phone_login', this.$qs.stringify({
                phone: this.phone,
                code: this.code,
            })).then((res)=>{
                if(res.data.code == 0 || res.data.result == 0) {
                    //登录成功
                    this.$message.success("登录成功")
                    window.location.href = this.redirectUrl
                }else{
                    this.$message.error(res.data.msg)
                }
            })
        },
        userLogin(){
            if(!this.agreeValPasswd){
                this.$message.error("请先同意隐私政策和用户协议")
                return
            }
            if(this.username == "") {
                this.$message.error("请输入账号")
                return
            }
            if(this.passwd == "") {
                this.$message.error("请输入密码")
                return
            }
            this.$axios.defaults.withCredentials = true
            this.$axios.post("https://"+this.domain+"/loginV2/m_confirm", this.$qs.stringify({
                nickname: this.username,
                passwd: this.passwd
            })).then((res)=>{
                if(res.data.result == 1) {
                    //登录成功
                    this.$message.success("登录成功")
                    window.location.href = this.redirectUrl
                }else{
                    this.$message.error(res.data.msg)
                }
            })
        },

    },
};
</script>
<style>
@import url("../assets/css/login.css");
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue